import { LockOutlined } from '@ant-design/icons';
import { Card, Select, Switch, Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import { TiendaPerfectaDistributor } from 'models/TiendaPerfecta';

import { FunctionsHelper } from 'utils/FunctionsHelper';

const I18N_BASE = 'scenes.vans.components.filters';

interface VansFiltersProps {
  distributors: TiendaPerfectaDistributor[];
  selectedDistributorId: string | undefined;
  onDistributorChange: (id: string) => void;
  /** Con un solo distribuidor no hay nada que elegir, pero sí que mostrar. */
  singleDistributor: boolean;
  includeInactive: boolean;
  onIncludeInactiveChange: (checked: boolean) => void;
  disabled?: boolean;
  vansCount: number;
}

function VansFilters({
  distributors,
  selectedDistributorId,
  onDistributorChange,
  singleDistributor,
  includeInactive,
  onIncludeInactiveChange,
  disabled = false,
  vansCount,
}: VansFiltersProps) {
  const { t } = useTranslation();

  return (
    <Card>
      <div className="vans-filters">
        <div className="vans-filters__left">
          <span className="vans-filters__label">
            {t(`${I18N_BASE}.distributor`)}
          </span>

          <Select
            value={selectedDistributorId}
            onChange={onDistributorChange}
            // Deshabilitado pero visible: esconderlo dejaría la vista sin decir
            // de qué distribuidor es la flota.
            disabled={disabled || singleDistributor}
            suffixIcon={singleDistributor ? <LockOutlined /> : undefined}
            options={distributors.map((distributor) => ({
              value: distributor.id,
              label: distributor.tradeName,
              title: `${distributor.tradeName} ${distributor.code}`,
            }))}
            showSearch
            filterOption={(search: string, option?: any) =>
              FunctionsHelper.normalizeText(option?.title ?? '').includes(
                FunctionsHelper.normalizeText(search)
              )
            }
            style={{ minWidth: 260 }}
          />

          {singleDistributor && (
            <Tag>{t(`${I18N_BASE}.single_distributor`)}</Tag>
          )}

          <span className="vans-filters__label vans-filters__label--spaced">
            {t(`${I18N_BASE}.include_inactive`)}
          </span>
          <Switch
            checked={includeInactive}
            onChange={onIncludeInactiveChange}
            disabled={disabled}
          />
        </div>

        <div className="vans-filters__right">
          {t(`${I18N_BASE}.summary`, { count: vansCount })}
        </div>
      </div>
    </Card>
  );
}

export default VansFilters;
